export const RADIO_TYPES = [{}, { isInvalid: true }, { disabled: true }]
